import axios from 'axios'
import { pluckData } from 'src/utilities/http-client'
import {
  CreateAssignmentPayload,
  GiveCourseCreditPayload,
  UpdateAssignmentPayload,
} from '../assignments/types'
import {
  CreateCompliancePayload,
  UpdateCompliancePayload,
} from '../compliance/types'
import { CreateGroupPayload, UpdateGroupPayload } from '../groups/types'
import {
  CreateTrainingSeriesPayload,
  UpdateTrainingSeriesPayload,
} from '../training-series/types'
import {
  ExternalCertificateImagePayload,
  ExternalCertificatePayload,
} from '../roster/types'

// Groups
export let createGroup = (data: CreateGroupPayload) =>
  axios.post<unknown>('/api/v2/manage/group', data)

export let updateGroup = (data: UpdateGroupPayload) =>
  axios.put<unknown>('/api/v2/manage/group', data)

export let deleteGroup = (id: string) =>
  axios.delete<unknown>(`/api/v2/manage/group?id=${id}`)

// Training Series
export let createTrainingSeries = (data: CreateTrainingSeriesPayload) =>
  axios.post<unknown>('/api/v2/manage/training-series', data)

export let updateTrainingSeries = (data: UpdateTrainingSeriesPayload) =>
  axios.put<unknown>('/api/v2/manage/training-series', data)

export let deleteTrainingSeries = (id: string) =>
  axios.delete<unknown>(`/api/v2/manage/training-series?trainingSeriesId=${id}`)

// Assignments
export let createAssignment = (data: CreateAssignmentPayload) => {
  let { linkedServiceID, name, dueDate, userIDs, courseIDs } = data

  return axios
    .post<{ id: string }>('/api/v2/manage/assignment', {
      linkedServiceID,
      name,
      dueDate,
      userIDs,
      courseIDs,
      groupIDs: [],
    })
    .then(pluckData)
}

// Compliance
export let getComplianceRequirement = (id: string) =>
  axios
    .get<{
      id: string
      name: string
      linkedServiceID: string
      issueDate: string
      expirationDate: string
      alertSetting: string
      alertType: string
      userIDs: string[]
    }>(`/api/manage/compliance/${id}`)
    .then(pluckData)

export let createComplianceRequirement = (data: CreateCompliancePayload) =>
  axios.post<{ id: string }>('/api/manage/compliance', data).then(pluckData)

export let updateComplianceRequirement = (
  id: string,
  data: UpdateCompliancePayload,
) => axios.put<unknown>(`/api/manage/compliance/${id}`, data).then(pluckData)

export let deleteComplianceRequirement = (id: string) =>
  axios.delete<unknown>(`/api/manage/compliance/${id}`).then(pluckData)

export let confirmThreshholdCompletions = (assignmentID: string) =>
  axios
    .post<unknown>('/api/manage/assignment-courses/complete/within-threshold', {
      assignmentID,
    })
    .then(pluckData)

export let updateAssignment = (data: UpdateAssignmentPayload) => {
  let { id, linkedServiceID, name, dueDate, userIDs, courseIDs } = data

  return axios
    .put<unknown>('/api/v2/manage/assignment', {
      id,
      linkedServiceID,
      name,
      courseIDs,
      userIDs,
      dueDate,
      groupIDs: [],
    })
    .then(pluckData)
}

export let deleteAssignment = (id: string) =>
  axios.delete<unknown>(`/api/v2/manage/assignment?id=${id}`).then(pluckData)

export let giveCourseCredit = (data: GiveCourseCreditPayload) =>
  axios.post('/api/manage/assignment-courses/complete', data)

// Certificates
export let addExternalCertificate = (data: ExternalCertificatePayload) =>
  axios
    .post<{ id: string }>('/api/v2/manage/external-certificate', data)
    .then(pluckData)

export let updateExternalCertificate = (data: ExternalCertificatePayload) =>
  axios
    .put<unknown>('/api/v2/manage/external-certificate', data)
    .then(pluckData)

export let updateExternalCertificateImage = (
  data: ExternalCertificateImagePayload,
) =>
  axios
    .put<string>(`/api/v2/manage/external-certificate-image`, data)
    .then(pluckData)

// Roster
export let inviteLinkedServiceUser = (
  linkedServiceID: string,
  userEmail: string,
) =>
  axios.post<unknown>(
    `/api/v2/manage/linked-service/invite?linkedServiceID=${linkedServiceID}`,
    { userEmail },
  )

export let bulkInviteLinkedServiceUsers = (
  linkedServiceID: string,
  csvFile: File,
) => {
  let formData = new FormData()
  formData.append('csvFile', csvFile)

  return axios.post<unknown>(
    `/api/v2/manage/linked-service/invite/bulk?linkedServiceID=${linkedServiceID}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
}
